export const logo: [number, number][] = [
  [8.175001497843756, 5.97009973310346],
  [8.874998446085943, 7.370101258982366],
  [4.774999971964849, 3.8701012589823662],
  [8.675001497843756, 6.77010087751264],
  [7.674999590495123, 8.47009973310346],
  [8.175001497843756, 8.570100114573187],
  [8.975000734904302, 9.87010030530805],
  [7.774999971964849, 7.0701001145731865],
  [4.975000734904302, 4.77010087751264],
  [9.175001497843756, 9.370101258982366],
  [7.574999209025396, 9.570100114573187],
  [7.274999971964849, 6.47009973310346],
  [8.27499997196485, 9.570100114573187],
  [5.875000353434576, 4.670100496042913],
  [8.374998446085943, 7.0701001145731865],
  [9.27499997196485, 8.370101258982366],
  [7.074999209025396, 5.370101258982366],
  [6.674999590495123, 6.77010087751264],
  [6.975000734904302, 4.5701001145731865],
  [8.074999209025396, 10.170100496042913],
  [4.174999590495123, 3.2701008775126397],
  [8.175001497843756, 7.5701001145731865],
  [9.175001497843756, 7.870101258982366],
  [5.375000353434576, 4.170100496042913],
  [8.675001497843756, 9.47009973310346],
  [7.874998446085943, 6.5701001145731865],
  [9.475000734904302, 8.870101258982366],
  [7.674999590495123, 10.170100496042913],
  [9.074999209025396, 8.77010087751264],
  [8.675001497843756, 7.870101258982366],
  [6.375000353434576, 4.97009973310346],
  [7.475000734904302, 7.670100496042913],
  [7.274999971964849, 8.170100496042913],
  [8.374998446085943, 6.370101258982366],
  [4.875000353434576, 3.0701001145731865],
  [7.475000734904302, 8.97009973310346],
  [5.975000734904302, 5.77010087751264],
  [4.174999590495123, 4.27010087751264],
  [8.074999209025396, 9.070100114573187],
  [5.574999209025396, 5.27010087751264],
  [5.674999590495123, 3.47009973310346],
  [9.574999209025396, 10.070100114573187],
  [6.375000353434576, 6.27010087751264],
  [7.674999590495123, 5.870101258982366],
  [6.574999209025396, 4.27010087751264],
  [6.975000734904302, 7.47009973310346],
  [7.074999209025396, 5.97009973310346],
  [7.475000734904302, 4.97009973310346],
  [8.475000734904302, 10.170100496042913],
  [7.874998446085943, 5.370101258982366],
  [3.375000353434576, 3.8701012589823662],
  [6.174999590495123, 3.8701012589823662],
  [9.574999209025396, 10.470100686777776],
  [8.574999209025396, 8.97009973310346],
  [7.975000734904302, 7.97009973310346],
  [3.375000353434576, 2.7701008775126397],
  [9.574999209025396, 9.570100114573187],
  [8.675001497843756, 8.370101258982366],
  [8.874998446085943, 10.37010030530805],
  [7.274999971964849, 7.0701001145731865],
  [6.574999209025396, 5.5701001145731865],
  [-5.325000409504877, 4.97009973310346],
  [-4.425000790974604, 4.27010087751264],
  [-5.925000790974604, 5.0701001145731865],
  [-2.7250000280351507, 4.27010087751264],
  [-3.2250000280351507, 3.8701012589823662],
  [-2.7250000280351507, 3.5701001145731865],
  [-6.124999646565424, 6.870101258982366],
  [-3.8250004095048773, 4.170100496042913],
  [-4.124999646565424, 5.0701001145731865],
  [-5.925000790974604, 7.170100496042913],
  [-5.725000028035151, 6.27010087751264],
  [-2.0249992650956976, 4.0701001145731865],
  [-4.325000409504877, 3.670100496042913],
  [-6.225000028035151, 6.47009973310346],
  [-6.024999265095698, 5.97009973310346],
  [-4.624999646565424, 4.77010087751264],
  [-5.024999265095698, 4.47009973310346],
  [-6.524999265095698, 5.97009973310346],
  [-6.725000028035151, 6.97009973310346],
  [-5.624999646565424, 4.5701001145731865],
  [-5.225000028035151, 6.170100496042913],
  [-6.725000028035151, 6.5701001145731865],
  [-6.225000028035151, 5.5701001145731865],
  [-4.925000790974604, 4.0701001145731865],
  [-5.524999265095698, 5.370101258982366],
  [-5.624999646565424, 5.77010087751264],
  [-3.2250000280351507, 3.0701001145731865],
  [-4.024999265095698, 4.670100496042913],
  [-5.624999646565424, 6.670100496042913],
  [-1.9250007909746039, 3.47009973310346],
  [-5.024999265095698, 5.27010087751264],
  [-2.3250004095048773, 2.7701008775126397],
  [-3.8250004095048773, 3.47009973310346],
  [-6.425000790974604, 7.370101258982366],
  [-4.524999265095698, 5.370101258982366],
  [-3.3250004095048773, 4.670100496042913],
  [-4.925000790974604, 5.77010087751264],
  [-9.525000218770014, -6.929897978078181],
  [-8.124999646565424, -6.129898741017634],
  [-8.424999837300287, -6.52990026689654],
  [-3.3250004095048773, -5.72989912248736],
  [-6.225000028035151, -5.4298998854268135],
  [-4.024999265095698, -6.129898741017634],
  [-4.425000790974604, -6.729901029835993],
  [-8.72500002803515, -5.829899503957087],
  [-9.22500002803515, -5.829899503957087],
  [-7.225000028035151, -6.22989912248736],
  [-7.825000409504877, -6.729901029835993],
  [-9.325000409504877, -6.329899503957087],
  [-10.124999646565424, -6.429897978078181],
  [-7.524999265095698, -5.329899503957087],
  [-8.22500002803515, -5.52990026689654],
  [-7.225000028035151, -6.829899503957087],
  [-9.825000409504877, -6.02990026689654],
  [-6.624999646565424, -6.02990026689654],
  [-5.925000790974604, -6.02990026689654],
  [-4.925000790974604, -5.4298998854268135],
  [-7.524999265095698, -5.829899503957087],
  [-4.124999646565424, -5.52990026689654],
  [-8.924999837300287, -6.52990026689654],
  [-5.925000790974604, -6.629898741017634],
  [-9.124999646565424, -7.129898741017634],
  [-8.22500002803515, -7.129898741017634],
  [-3.5249992650956976, -6.829899503957087],
  [-5.124999646565424, -6.02990026689654],
  [-5.225000028035151, -6.629898741017634],
  [-6.825000409504877, -5.4298998854268135],
  [-5.624999646565424, -5.4298998854268135],
  [-6.624999646565424, -6.629898741017634],
  [-8.825000409504877, -7.429897978078181],
  [-0.42500079097460386, 0.07010011457318654],
  [1.9750007349043024, 12.670100496042913],
  [2.574999209025396, 5.97009973310346],
  [-11.72500002803515, -9.129898741017634],
  [-1.7250000280351507, -8.129898741017634],
  [0.6749995904951227, 6.0701001145731865],
  [-2.3250004095048773, -8.129898741017634],
  [-0.42500079097460386, -6.929897978078181],
  [-0.6249996465654242, 5.27010087751264],
  [-0.02499926509569761, -2.829899503957087],
  [1.3750003534345758, 2.97009973310346],
  [1.9750007349043024, 11.570100114573187],
  [1.0749992090253961, -2.6298987410176338],
  [0.4750007349043024, -6.129898741017634],
  [-2.7250000280351507, -7.52990026689654],
  [-10.22500002803515, -10.629898741017634],
  [2.875000353434576, 7.77010087751264],
  [2.7749999719648493, 7.27010087751264],
  [-4.325000409504877, -10.629898741017634],
  [-1.3250004095048773, -0.9298998854268135],
  [2.1749995904951227, 3.7701008775126397],
  [0.6749995904951227, 2.7701008775126397],
  [7.274999971964849, 12.570100114573187],
  [-2.8250004095048773, -8.829899503957087],
  [0.1749995904951227, 6.5701001145731865],
  [-2.0249992650956976, -7.52990026689654],
  [6.674999590495123, 14.77010087751264],
  [-1.8250004095048773, -10.02990026689654],
  [1.5749992090253961, -0.7298991224873603],
  [-0.02499926509569761, -5.52990026689654],
  [-1.2250000280351507, -0.3298995039570869],
  [-6.524999265095698, -12.229901029835993],
  [-1.1249996465654242, 0.1701004960429131],
  [5.574999209025396, 13.170100496042913],
  [-2.0249992650956976, -4.829899503957087],
  [-0.12499964656542417, -1.02990026689654],
  [1.9750007349043024, 2.670100496042913],
  [-0.7250000280351507, -0.7298991224873603],
  [-1.1249996465654242, -5.02990026689654],
  [8.975000734904302, 13.070100114573187],
  [-3.425000790974604, -8.829899503957087],
  [0.07499920902539614, 0.5701001145731865],
  [0.8750003534345758, 2.170100496042913],
  [1.8750003534345758, 1.47009973310346],
  [0.37500035343457583, -0.029900266896540018],
  [-2.925000790974604, -10.629898741017634],
  [1.1749995904951227, 4.27010087751264],
  [-0.5249992650956976, -7.829899503957087],
  [-10.624999646565424, -6.629898741017634],
  [0.07499920902539614, 8.070100114573187],
  [3.875000353434576, 10.570100114573187],
  [-8.124999646565424, -10.129898741017634],
  [-6.825000409504877, -11.629898741017634],
  [-9.424999837300287, -7.629898741017634],
  [4.674999590495123, 13.37010030530805],
  [-0.22500002803515073, 1.8701012589823662],
  [0.7749999719648493, -1.7298991224873603],
  [0.37500035343457583, 7.370101258982366],
  [0.37500035343457583, -6.629898741017634],
  [1.4750007349043024, 2.3701012589823662],
  [1.2749999719648493, 1.97009973310346],
  [-9.025000218770014, -12.02990026689654],
  [-7.024999265095698, -10.829899503957087],
  [0.4750007349043024, -0.7298991224873603],
  [-9.825000409504877, -11.729901029835993],
  [3.7749999719648493, 14.27010087751264],
  [-0.6249996465654242, -2.02990026689654],
  [-9.624999646565424, -8.129898741017634],
  [-9.325000409504877, -11.42989797807818],
  [-2.425000790974604, -7.02990026689654],
  [-0.5249992650956976, -8.42989797807818],
  [3.375000353434576, 9.27010087751264],
  [-4.725000028035151, -12.129898741017634],
  [-11.72500002803515, -8.52990026689654],
  [-0.12499964656542417, -0.42989988542681346],
  [1.5749992090253961, 8.570100114573187],
  [-0.22500002803515073, 3.0701001145731865],
  [0.27499997196484927, -1.52990026689654],
  [0.5749992090253961, -5.52990026689654],
  [-0.8250004095048773, 2.7701008775126397],
  [8.77499997196485, 12.37010030530805],
  [-3.124999646565424, -11.42989797807818],
  [-8.325000409504877, -10.92989797807818],
  [-1.8250004095048773, -6.52990026689654],
  [1.6749995904951227, 9.77010087751264],
  [-9.624999646565424, -9.729901029835993],
  [1.9750007349043024, 6.47009973310346],
  [0.8750003534345758, 1.3701012589823662],
  [-7.624999646565424, -10.329899503957087],
  [0.7749999719648493, 6.77010087751264],
  [1.2749999719648493, -2.1298987410176338],
  [1.6749995904951227, 11.070100114573187],
  [-10.325000409504877, -9.129898741017634],
  [-9.924999837300287, -7.229901029835993],
  [-0.42500079097460386, 0.7701008775126397],
  [0.9750007349043024, 3.2701008775126397],
  [0.27499997196484927, 1.170100496042913],
  [0.37500035343457583, 1.97009973310346],
  [1.6749995904951227, 7.47009973310346],
  [0.1749995904951227, -7.02990026689654],
  [0.9750007349043024, -1.1298987410176338],
  [1.8750003534345758, 5.27010087751264],
  [2.074999209025396, 3.2701008775126397],
  [8.175001497843756, 11.37010030530805],
  [-7.325000409504877, -11.42989797807818],
  [-7.725000028035151, -10.92989797807818],
  [9.27499997196485, 12.470100686777776],
  [0.9750007349043024, 7.47009973310346],
  [7.174999590495123, 13.77010087751264],
  [0.8750003534345758, 4.870101258982366],
  [-9.124999646565424, -10.92989797807818],
  [-10.325000409504877, -11.329899503957087],
  [1.7749999719648493, 0.47009973310346],
  [1.7749999719648493, 0.97009973310346],
  [1.2749999719648493, 0.8701012589823662],
  [-9.22500002803515, -10.229901029835993],
  [-11.525000218770014, -7.929897978078181],
  [2.4750007349043024, 5.27010087751264],
  [-5.925000790974604, -12.129898741017634],
  [1.4750007349043024, -1.4298998854268135],
  [0.37500035343457583, -4.22989912248736],
  [4.975000734904302, 12.87010030530805],
  [0.5749992090253961, 3.670100496042913],
  [8.27499997196485, 12.070100114573187],
  [1.2749999719648493, 6.370101258982366],
  [1.1749995904951227, 9.27010087751264],
  [-11.424999837300287, -10.229901029835993],
  [-8.624999646565424, -10.42989797807818],
  [2.375000353434576, 4.5701001145731865],
  [4.375000353434576, 13.87010030530805],
  [4.875000353434576, 14.070100114573187],
  [0.7749999719648493, 8.070100114573187],
  [-1.6249996465654242, -5.22989912248736],
  [-11.22500002803515, -9.129898741017634],
  [3.574999209025396, 9.87010030530805],
  [0.07499920902539614, 5.870101258982366],
  [-1.6249996465654242, -9.329899503957087],
  [1.3750003534345758, 5.870101258982366],
  [-4.124999646565424, -11.92989797807818],
  [0.07499920902539614, -8.229901029835993],
  [-8.325000409504877, -12.129898741017634],
  [1.3750003534345758, 7.97009973310346],
  [-8.825000409504877, -9.729901029835993],
  [-10.325000409504877, -8.329899503957087],
  [-0.42500079097460386, 6.0701001145731865],
  [1.4750007349043024, 11.970100686777776],
  [0.4750007349043024, -2.329899503957087],
  [6.774999971964849, 12.37010030530805],
  [-4.425000790974604, -11.329899503957087],
  [-0.5249992650956976, -1.4298998854268135],
  [8.77499997196485, 11.470100686777776],
  [4.375000353434576, 14.570100114573187],
  [-0.12499964656542417, 7.370101258982366],
  [8.175001497843756, 10.77010087751264],
  [-8.024999265095698, -11.629898741017634],
  [-5.425000790974604, -12.129898741017634],
  [1.4750007349043024, 3.670100496042913],
  [-0.42500079097460386, 2.3701012589823662],
  [0.5749992090253961, 9.87010030530805],
  [-10.825000409504877, -11.02990026689654],
  [-10.525000218770014, -7.129898741017634],
  [0.6749995904951227, 0.6701004960429131],
  [-1.8250004095048773, -3.829899503957087],
  [-5.024999265095698, -11.629898741017634],
  [6.375000353434576, 13.070100114573187],
  [1.0749992090253961, -3.2298991224873603],
  [-1.0249992650956976, -5.72989912248736],
  [3.2749999719648493, 13.070100114573187],
  [4.475000734904302, 11.77010087751264],
  [-1.0249992650956976, -1.4298998854268135],
  [-10.624999646565424, -10.229901029835993],
  [2.1749995904951227, 7.0701001145731865],
  [-5.624999646565424, -10.829899503957087],
  [-1.5249992650956976, -1.829899503957087],
  [0.27499997196484927, 8.570100114573187],
  [2.074999209025396, 7.870101258982366],
  [-5.624999646565424, -11.42989797807818],
  [-0.6249996465654242, -6.22989912248736],
  [-0.8250004095048773, -7.429897978078181],
  [-1.1249996465654242, -6.929897978078181],
  [-4.925000790974604, -10.42989797807818],
  [4.975000734904302, 14.77010087751264],
  [0.1749995904951227, 2.5701001145731865],
  [-1.1249996465654242, 0.7701008775126397],
  [-1.6249996465654242, -7.129898741017634],
  [-0.12499964656542417, -8.92989797807818],
  [2.6749995904951227, 6.670100496042913],
  [1.3750003534345758, 6.870101258982366],
  [-7.124999646565424, -10.329899503957087],
  [0.9750007349043024, -4.329899503957087],
  [0.9750007349043024, -0.42989988542681346],
  [8.77499997196485, 10.87010030530805],
  [3.1749995904951227, 8.47009973310346],
  [0.1749995904951227, -3.52990026689654],
  [9.475000734904302, 11.37010030530805],
  [-0.9250007909746039, 2.0701001145731865],
  [0.07499920902539614, 3.5701001145731865],
  [1.0749992090253961, 0.1701004960429131],
  [-0.12499964656542417, 5.170100496042913],
  [-0.7250000280351507, 3.97009973310346],
  [1.5749992090253961, -0.029900266896540018],
  [1.8750003534345758, 2.0701001145731865],
  [-0.3250004095048773, 1.2701008775126397],
  [-1.0249992650956976, 1.3701012589823662],
  [1.1749995904951227, 11.37010030530805],
  [7.774999971964849, 12.970100686777776],
  [2.2749999719648493, 10.070100114573187],
  [1.8750003534345758, 10.570100114573187],
  [1.9750007349043024, 5.870101258982366],
  [-4.024999265095698, -10.02990026689654],
  [3.2749999719648493, 13.970100686777776],
  [9.374998446085943, 11.87010030530805],
  [0.4750007349043024, 4.27010087751264],
  [-10.924999837300287, -7.729901029835993],
  [-0.42500079097460386, -4.72989912248736],
  [9.475000734904302, 10.87010030530805],
  [-3.0249992650956976, -9.92989797807818],
  [-3.425000790974604, -9.52990026689654],
  [4.375000353434576, 12.670100496042913],
  [-3.5249992650956976, -10.329899503957087],
  [-2.425000790974604, -6.429897978078181],
  [6.574999209025396, 13.670100496042913],
  [8.175001497843756, 13.970100686777776],
  [5.274999971964849, 13.670100496042913],
  [0.37500035343457583, 9.170100496042913],
  [0.9750007349043024, 8.670100496042913],
  [-1.0249992650956976, -4.52990026689654],
  [0.07499920902539614, -7.629898741017634],
  [1.7749999719648493, 4.170100496042913],
  [-1.6249996465654242, -2.6298987410176338],
  [-1.1249996465654242, -8.52990026689654],
  [0.7749999719648493, -4.9298998854268135],
  [2.574999209025396, 11.670100496042913],
  [5.975000734904302, 13.570100114573187],
  [-1.7250000280351507, -8.729901029835993],
  [-6.225000028035151, -11.42989797807818],
  [-9.525000218770014, -9.229901029835993],
  [7.274999971964849, 11.87010030530805],
  [-0.02499926509569761, -2.02990026689654],
  [-7.624999646565424, -12.129898741017634],
  [1.1749995904951227, 5.27010087751264],
  [-9.72500002803515, -10.92989797807818],
  [-0.6249996465654242, 4.5701001145731865],
  [-2.425000790974604, -10.729901029835993],
  [-1.1249996465654242, -2.4298998854268135],
  [4.174999590495123, 11.170100496042913],
  [-0.7250000280351507, 3.47009973310346],
  [1.7749999719648493, 9.170100496042913],
  [-0.02499926509569761, 4.170100496042913],
  [0.27499997196484927, 4.870101258982366],
  [-1.9250007909746039, -11.02990026689654],
  [0.5749992090253961, -3.02990026689654],
  [4.875000353434576, 12.170100496042913],
  [-9.825000409504877, -10.229901029835993],
  [2.4750007349043024, 13.27010087751264],
  [-7.124999646565424, -12.229901029835993],
  [-6.425000790974604, -10.229901029835993],
  [-2.3250004095048773, -8.729901029835993],
  [1.5749992090253961, 4.77010087751264],
  [-1.5249992650956976, -10.629898741017634],
  [0.5749992090253961, 5.47009973310346],
  [-0.5249992650956976, -2.7298991224873603],
  [8.374998446085943, 12.87010030530805],
  [-0.3250004095048773, 6.77010087751264],
  [-1.0249992650956976, -3.1298987410176338],
  [5.875000353434576, 14.070100114573187],
  [0.9750007349043024, 9.77010087751264],
  [-1.2250000280351507, -7.829899503957087],
  [-5.925000790974604, -10.329899503957087],
  [-2.425000790974604, -10.129898741017634],
  [2.7749999719648493, 8.97009973310346],
  [-0.42500079097460386, -3.4298998854268135],
  [-0.5249992650956976, -9.629898741017634],
  [2.1749995904951227, 8.670100496042913],
  [3.6749995904951227, 11.570100114573187],
  [5.975000734904302, 14.77010087751264],
  [-2.2250000280351507, -5.72989912248736],
  [2.574999209025396, 8.27010087751264],
  [-0.12499964656542417, -6.129898741017634],
  [7.674999590495123, 10.87010030530805],
  [-10.22500002803515, -7.729901029835993],
  [2.1749995904951227, 12.170100496042913],
  [7.774999971964849, 13.470100686777776],
  [-1.7250000280351507, -5.9298998854268135],
  [-1.6249996465654242, -3.2298991224873603],
  [-0.6249996465654242, -5.4298998854268135],
  [-5.325000409504877, -10.02990026689654],
  [-9.825000409504877, -8.629898741017634],
  [2.2749999719648493, 9.370101258982366],
  [-3.0249992650956976, -8.229901029835993],
  [-2.7250000280351507, -9.42989797807818],
  [2.875000353434576, 9.670100496042913],
  [-10.72500002803515, -8.829899503957087],
  [1.2749999719648493, 10.37010030530805],
  [3.2749999719648493, 10.27010087751264],
  [-1.2250000280351507, -3.829899503957087],
  [0.8750003534345758, 10.670100496042913],
  [-0.8250004095048773, -9.02990026689654],
  [-3.5249992650956976, -11.829899503957087],
  [6.574999209025396, 14.170100496042913],
  [0.1749995904951227, -4.9298998854268135],
  [-4.024999265095698, -9.329899503957087],
  [-1.2250000280351507, -9.629898741017634],
  [-10.22500002803515, -9.729901029835993],
  [-0.12499964656542417, -4.129898741017634],
  [-1.7250000280351507, -4.4298998854268135],
  [5.475000734904302, 12.470100686777776],
  [2.6749995904951227, 10.470100686777776],
  [-0.7250000280351507, -4.02990026689654],
  [-6.325000409504877, -10.829899503957087],
  [3.9750007349043024, 13.070100114573187],
  [0.8750003534345758, -3.7298991224873603],
  [-4.925000790974604, -10.92989797807818],
  [4.074999209025396, 12.170100496042913],
  [5.475000734904302, 14.570100114573187],
  [-8.624999646565424, -11.52990026689654],
  [-1.2250000280351507, -6.429897978078181],
  [2.375000353434576, 10.970100686777776],
  [-10.924999837300287, -9.629898741017634],
  [7.674999590495123, 14.27010087751264],
  [-2.2250000280351507, -9.42989797807818],
  [6.074999209025396, 12.570100114573187],
  [3.375000353434576, 10.970100686777776],
  [-11.624999646565424, -9.729901029835993],
  [7.574999209025396, 11.470100686777776],
  [2.875000353434576, 11.27010087751264],
  [7.274999971964849, 14.470100686777776],
  [-1.0249992650956976, -10.229901029835993],
  [3.2749999719648493, 11.87010030530805],
  [-11.22500002803515, -7.229901029835993],
  [-11.025000218770014, -8.329899503957087],
  [-4.624999646565424, -9.829899503957087],
  [-3.925000790974604, -11.229901029835993],
  [-3.5249992650956976, -10.92989797807818],
  [-11.124999646565424, -10.629898741017634],
  [-2.624999646565424, -11.329899503957087],
  [2.875000353434576, 12.27010087751264],
  [3.574999209025396, 12.470100686777776],
  [2.9750007349043024, 13.570100114573187],
  [8.574999209025396, 13.570100114573187],
  [2.6749995904951227, 12.77010087751264],
  [3.7749999719648493, 13.570100114573187],
  [7.874998446085943, 12.27010087751264],
  [7.074999209025396, 13.070100114573187],
  [-1.5249992650956976, 4.47009973310346],
  [-4.425000790974604, 5.870101258982366],
  [-2.925000790974604, 4.870101258982366],
  [-6.524999265095698, 7.670100496042913],
  [-2.3250004095048773, 4.670100496042913],
  [-4.825000409504877, 6.170100496042913],
  [-3.5249992650956976, 5.170100496042913],
  [-4.024999265095698, 5.47009973310346],
  [-5.425000790974604, 6.97009973310346],
  [-5.124999646565424, 6.5701001145731865],
  [-6.024999265095698, 7.670100496042913],
  [-5.725000028035151, 7.370101258982366],
  [-6.624999646565424, 5.47009973310346],
  [-5.524999265095698, 4.0701001145731865],
  [-4.825000409504877, 3.47009973310346],
  [-3.7250000280351507, 2.8701012589823662],
  [-2.5249992650956976, 2.3701012589823662],
  [-5.225000028035151, 3.7701008775126397],
  [-6.425000790974604, 5.0701001145731865],
  [-6.124999646565424, 4.670100496042913],
  [-5.825000409504877, 4.370101258982366],
  [-6.825000409504877, 5.870101258982366],
  [-1.8250004095048773, 2.170100496042913],
  [-7.024999265095698, 6.670100496042913],
  [-3.124999646565424, 2.5701001145731865],
  [-6.925000790974604, 6.170100496042913],
  [-7.024999265095698, 7.0701001145731865],
  [-6.825000409504877, 7.47009973310346],
  [-4.325000409504877, 3.170100496042913],
  [-6.225000028035151, -7.129898741017634],
  [-5.225000028035151, -7.129898741017634],
  [-8.424999837300287, -7.629898741017634],
  [-7.624999646565424, -7.329899503957087],
  [-8.024999265095698, -7.429897978078181],
  [-8.72500002803515, -7.829899503957087],
  [-4.024999265095698, -7.329899503957087],
  [-6.725000028035151, -7.129898741017634],
  [-5.725000028035151, -7.129898741017634],
  [-7.124999646565424, -7.229901029835993],
  [-4.624999646565424, -7.229901029835993],
  [-6.524999265095698, -4.9298998854268135],
  [-7.225000028035151, -4.9298998854268135],
  [-7.825000409504877, -5.02990026689654],
  [-8.525000218770014, -5.129898741017634],
  [-9.124999646565424, -5.329899503957087],
  [-5.725000028035151, -4.9298998854268135],
  [-5.024999265095698, -4.9298998854268135],
  [-9.72500002803515, -5.52990026689654],
  [-4.225000028035151, -5.02990026689654],
  [-3.3250004095048773, -5.129898741017634],
  [-10.325000409504877, -5.829899503957087],
  [4.574999209025396, -11.42989797807818],
  [3.2749999719648493, -10.229901029835993],
  [4.774999971964849, -10.829899503957087],
  [1.7749999719648493, -9.129898741017634],
  [3.574999209025396, -8.829899503957087],
  [6.475000734904302, -13.02990026689654],
  [3.375000353434576, -9.52990026689654],
  [3.9750007349043024, -9.329899503957087],
  [5.174999590495123, -10.629898741017634],
  [6.674999590495123, -12.42989797807818],
  [6.774999971964849, -13.229901029835993],
  [2.375000353434576, -9.52990026689654],
  [6.875000353434576, -12.829899503957087],
  [5.774999971964849, -12.42989797807818],
  [4.174999590495123, -11.129898741017634],
  [4.975000734904302, -11.829899503957087],
  [4.375000353434576, -10.229901029835993],
  [3.6749995904951227, -10.629898741017634],
  [5.375000353434576, -12.229901029835993],
  [5.674999590495123, -11.329899503957087],
  [4.375000353434576, -9.629898741017634],
  [6.074999209025396, -12.829899503957087],
  [2.875000353434576, -9.92989797807818],
  [1.1749995904951227, -8.629898741017634],
  [2.875000353434576, -8.329899503957087],
  [2.875000353434576, -9.02990026689654],
  [5.475000734904302, -11.729901029835993],
  [2.2749999719648493, -7.929897978078181],
  [6.274999971964849, -12.42989797807818],
  [6.074999209025396, -11.52990026689654],
  [2.2749999719648493, -8.729901029835993],
  [5.574999209025396, -10.92989797807818],
  [1.3750003534345758, -7.329899503957087],
  [3.7749999719648493, -10.02990026689654],
  [5.074999209025396, -11.329899503957087],
  [6.475000734904302, -11.92989797807818],
  [1.5749992090253961, -8.129898741017634],
  [4.875000353434576, -10.229901029835993],
  [4.274999971964849, -10.629898741017634],
  [5.975000734904302, -11.92989797807818],
  [5.375000353434576, -12.729901029835993],
  [6.475000734904302, -13.52990026689654],
  [6.975000734904302, -13.52990026689654],
  [3.9750007349043024, -11.42989797807818],
  [4.375000353434576, -11.729901029835993],
  [4.674999590495123, -12.129898741017634],
  [3.574999209025396, -11.129898741017634],
  [5.074999209025396, -12.42989797807818],
  [3.1749995904951227, -10.729901029835993],
  [2.1749995904951227, -10.02990026689654],
  [2.6749995904951227, -10.42989797807818],
  [1.0749992090253961, -9.229901029835993],
  [6.174999590495123, -13.329899503957087],
  [5.774999971964849, -13.02990026689654],
  [1.6749995904951227, -9.629898741017634],
  [4.174999590495123, -8.829899503957087],
  [5.574999209025396, -10.329899503957087],
  [4.574999209025396, -9.229901029835993],
  [7.174999590495123, -13.329899503957087],
  [7.274999971964849, -12.92989797807818],
  [2.1749995904951227, -7.229901029835993],
  [3.6749995904951227, -8.42989797807818],
  [6.174999590495123, -11.02990026689654],
  [4.875000353434576, -9.629898741017634],
  [3.2749999719648493, -8.02990026689654],
  [7.174999590495123, -12.52990026689654],
  [5.274999971964849, -10.02990026689654],
  [2.7749999719648493, -7.629898741017634],
  [6.975000734904302, -12.129898741017634],
  [5.875000353434576, -10.729901029835993],
  [1.5749992090253961, -6.829899503957087],
  [6.475000734904302, -11.42989797807818],
  [6.674999590495123, -11.829899503957087],
  [6.975000734904302, 8.47009973310346],
  [7.174999590495123, 9.570100114573187],
  [5.774999971964849, 6.170100496042913],
  [5.375000353434576, 5.77010087751264],
  [4.174999590495123, 4.870101258982366],
  [6.074999209025396, 6.5701001145731865],
  [3.2749999719648493, 4.47009973310346],
  [3.7749999719648493, 4.670100496042913],
  [7.274999971964849, 10.170100496042913],
  [6.774999971964849, 7.97009973310346],
  [7.074999209025396, 9.070100114573187],
  [6.375000353434576, 7.0701001145731865],
  [5.074999209025396, 5.47009973310346],
  [6.574999209025396, 7.47009973310346],
  [4.674999590495123, 5.170100496042913],
  [9.27499997196485, 7.0701001145731865],
  [3.574999209025396, 2.170100496042913],
  [8.675001497843756, 5.870101258982366],
  [6.174999590495123, 3.2701008775126397],
  [8.27499997196485, 5.370101258982366],
  [7.574999209025396, 4.47009973310346],
  [8.975000734904302, 6.47009973310346],
  [7.975000734904302, 4.870101258982366],
  [2.7749999719648493, 2.0701001145731865],
  [9.675001497843756, 8.27010087751264],
  [9.874998446085943, 8.870101258982366],
  [10.074999209025396, 10.170100496042913],
  [5.574999209025396, 2.97009973310346],
  [4.975000734904302, 2.670100496042913],
  [4.274999971964849, 2.3701012589823662],
  [9.475000734904302, 7.670100496042913],
  [9.975000734904302, 9.47009973310346],
  [6.674999590495123, 3.5701001145731865],
  [7.174999590495123, 3.97009973310346],
  [4.774999971964849, 15.170100496042913],
  [-0.9250007909746039, 5.370101258982366],
  [1.2749999719648493, 12.37010030530805],
  [8.374998446085943, 14.37010030530805],
  [-5.124999646565424, -9.52990026689654],
  [-2.925000790974604, -6.929897978078181],
  [-2.2250000280351507, -3.829899503957087],
  [-1.1249996465654242, 4.370101258982366],
  [-1.2250000280351507, 3.2701008775126397],
  [-2.0249992650956976, -2.7298991224873603],
  [7.975000734904302, 14.670100496042913],
  [-1.7250000280351507, -0.6298987410176338],
  [5.375000353434576, 15.170100496042913],
  [-0.3250004095048773, 8.47009973310346],
  [9.77499997196485, 12.37010030530805],
  [-2.124999646565424, -3.329899503957087],
  [4.274999971964849, 14.970100686777776],
  [-2.8250004095048773, -6.429897978078181],
  [5.875000353434576, 15.27010087751264],
  [1.8750003534345758, 13.170100496042913],
  [-1.3250004095048773, 2.170100496042913],
  [-9.124999646565424, -9.02990026689654],
  [7.475000734904302, 14.87010030530805],
  [-7.225000028035151, -9.829899503957087],
  [8.675001497843756, 14.070100114573187],
  [-3.124999646565424, -7.429897978078181],
  [3.375000353434576, 14.570100114573187],
  [-9.22500002803515, -8.52990026689654],
  [-4.624999646565424, -9.329899503957087],
  [-2.3250004095048773, -4.329899503957087],
  [-0.5249992650956976, 7.47009973310346],
  [-2.425000790974604, -4.829899503957087],
  [-1.0249992650956976, 4.870101258982366],
  [-8.72500002803515, -9.42989797807818],
  [-3.925000790974604, -8.729901029835993],
  [0.7749999719648493, 11.470100686777776],
  [-8.325000409504877, -9.629898741017634],
  [6.975000734904302, 15.070100114573187],
  [-3.5249992650956976, -8.329899503957087],
  [-1.9250007909746039, -2.2298991224873603],
  [-0.6249996465654242, 6.97009973310346],
  [2.1749995904951227, 13.570100114573187],
  [0.9750007349043024, 11.87010030530805],
  [-1.3250004095048773, 2.670100496042913],
  [-2.5249992650956976, -5.4298998854268135],
  [3.875000353434576, 14.87010030530805],
  [-0.8250004095048773, 5.870101258982366],
  [-1.4250007909746039, 1.5701001145731865],
  [0.1749995904951227, 9.970100686777776],
  [-1.6249996465654242, -0.029900266896540018],
  [0.37500035343457583, 10.470100686777776],
  [-9.025000218770014, -8.129898741017634],
  [9.074999209025396, 13.77010087751264],
  [-1.5249992650956976, 1.0701001145731865],
  [9.27499997196485, 13.37010030530805],
  [2.9750007349043024, 14.27010087751264],
  [-4.225000028035151, -9.02990026689654],
  [-2.624999646565424, -5.9298998854268135],
  [-1.9250007909746039, -1.7298991224873603],
  [-5.624999646565424, -9.729901029835993],
  [6.475000734904302, 15.170100496042913],
  [-1.8250004095048773, -1.1298987410176338],
  [-3.3250004095048773, -7.929897978078181],
  [-6.124999646565424, -9.829899503957087],
  [9.574999209025396, 12.87010030530805],
  [-1.5249992650956976, 0.47009973310346],
  [-6.624999646565424, -9.829899503957087],
  [-1.2250000280351507, 3.7701008775126397],
  [9.874998446085943, 11.87010030530805],
  [-0.7250000280351507, 6.47009973310346],
  [0.5749992090253961, 10.970100686777776],
  [10.074999209025396, 10.77010087751264],
  [-7.825000409504877, -9.729901029835993],
  [-0.12499964656542417, 8.97009973310346],
  [2.574999209025396, 13.970100686777776],
  [9.975000734904302, 11.37010030530805],
  [-0.42500079097460386, 7.97009973310346],
  [-0.02499926509569761, 9.47009973310346],
  [1.5749992090253961, 12.77010087751264],
  [-11.924999837300287, -10.42989797807818],
  [-12.025000218770014, -9.92989797807818],
  [-2.3250004095048773, -11.829899503957087],
  [-7.024999265095698, -12.729901029835993],
  [-11.124999646565424, -6.52990026689654],
  [-5.825000409504877, -12.729901029835993],
  [4.274999971964849, 10.37010030530805],
  [2.875000353434576, 5.170100496042913],
  [1.1749995904951227, -5.22989912248736],
  [-9.124999646565424, -12.42989797807818],
  [-0.42500079097460386, -10.229901029835993],
  [-5.325000409504877, -12.729901029835993],
  [1.3750003534345758, -4.72989912248736],
  [-1.4250007909746039, -11.229901029835993],
  [4.074999209025396, 9.87010030530805],
  [-1.8250004095048773, -11.52990026689654],
  [-4.225000028035151, -12.52990026689654],
  [2.4750007349043024, 2.0701001145731865],
  [2.9750007349043024, 5.670100496042913],
  [3.875000353434576, 9.370101258982366],
  [3.7749999719648493, 8.870101258982366],
  [3.4750007349043024, 7.870101258982366],
  [-11.424999837300287, -6.929897978078181],
  [-0.12499964656542417, -9.829899503957087],
  [1.4750007349043024, -3.7298991224873603],
  [-1.1249996465654242, -10.92989797807818],
  [4.475000734904302, 10.77010087751264],
  [-12.22500002803515, -8.829899503957087],
  [1.4750007349043024, -4.22989912248736],
  [1.5749992090253961, -3.1298987410176338],
  [1.6749995904951227, -2.6298987410176338],
  [2.6749995904951227, 3.5701001145731865],
  [5.475000734904302, 11.970100686777776],
  [2.574999209025396, 3.0701001145731865],
  [-10.72500002803515, -6.22989912248736],
  [-7.524999265095698, -12.729901029835993],
  [2.074999209025396, -0.029900266896540018],
  [1.8750003534345758, -1.6298987410176338],
  [1.7749999719648493, -2.1298987410176338],
  [0.4750007349043024, -8.329899503957087],
  [1.9750007349043024, -1.1298987410176338],
  [-6.425000790974604, -12.729901029835993],
  [2.375000353434576, 1.5701001145731865],
  [-4.725000028035151, -12.629898741017634],
  [2.074999209025396, -0.52990026689654],
  [-8.624999646565424, -12.629898741017634],
  [2.1749995904951227, 0.47009973310346],
  [4.774999971964849, 11.170100496042913],
  [-8.124999646565424, -12.629898741017634],
  [-3.7250000280351507, -12.42989797807818],
  [-2.7250000280351507, -12.02990026689654],
  [-10.025000218770014, -12.129898741017634],
  [-11.924999837300287, -7.829899503957087],
  [-12.124999646565424, -8.329899503957087],
  [-3.2250000280351507, -12.229901029835993],
  [3.2749999719648493, 7.27010087751264],
  [-0.7250000280351507, -10.629898741017634],
  [2.7749999719648493, 4.670100496042913],
  [2.2749999719648493, 0.97009973310346],
  [-9.624999646565424, -12.329899503957087],
  [-10.924999837300287, -11.629898741017634],
  [2.4750007349043024, 2.5701001145731865],
  [0.1749995904951227, -9.329899503957087],
  [2.6749995904951227, 4.170100496042913],
  [3.074999209025396, 6.27010087751264],
  [-11.72500002803515, -7.329899503957087],
  [-11.325000409504877, -11.229901029835993],
  [5.074999209025396, 11.570100114573187],
  [0.37500035343457583, -8.829899503957087],
  [3.1749995904951227, 6.77010087751264],
  [1.0749992090253961, -5.829899503957087],
  [0.8750003534345758, -6.829899503957087],
  [0.9750007349043024, -6.329899503957087],
  [0.6749995904951227, -7.829899503957087],
  [-12.124999646565424, -9.42989797807818],
  [-10.525000218770014, -11.829899503957087],
  [-11.624999646565424, -10.829899503957087],
  [0.7749999719648493, -7.329899503957087],
  [3.574999209025396, 8.370101258982366],
  [7.174999590495123, 11.170100496042913],
  [7.274999971964849, 10.570100114573187],
  [6.574999209025396, 11.970100686777776],
  [5.975000734904302, 12.170100496042913],
  [6.975000734904302, 11.670100496042913],
];
